// extracted by mini-css-extract-plugin
export default {"buildingCard":"FarmBuilding_buildingCard__IHo3A","info":"FarmBuilding_info__ydaG9"};